import { render, staticRenderFns } from "./UsersAdd.vue?vue&type=template&id=804e7b00&"
import script from "./UsersAdd.vue?vue&type=script&lang=js&"
export * from "./UsersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports